import { render, staticRenderFns } from "./MobileDialogContent.vue?vue&type=template&id=483b0382&scoped=true&"
import script from "./MobileDialogContent.vue?vue&type=script&lang=js&"
export * from "./MobileDialogContent.vue?vue&type=script&lang=js&"
import style0 from "./MobileDialogContent.vue?vue&type=style&index=0&id=483b0382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483b0382",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
